import { FileSources } from '@dynamik/common/clients/inboxv2-clients';

export class FileSourcesValueConverter {
  toView(ft: FileSources): string {
    switch (ft) {
      case FileSources.HandelsBankenExcel: return 'Handelsbanken Excel';
      case FileSources.HandelsBankenJSON: return 'Handelsbanken JSON';
      case FileSources.NordnetTransactions: return 'Nordnet';
      case FileSources.NordnetXml: return 'Nordnet XML';
      case FileSources.OdinJson: return 'Odin JSON';
      case FileSources.ParetoJson: return 'Pareto JSON';
      case FileSources.ParetoPortfolioReport: return 'Pareto portfolio report';
      case FileSources.ParetoXml: return 'Pareto XML';
      case FileSources.Pdf: return 'PDF';
      case FileSources.SB1Markets: return 'SB1 markets';
      case FileSources.VpsExcelEN: return 'VPS Excel (ENG)';
      case FileSources.VpsExcelNO: return 'VPS Excel (NO)';
      case FileSources.VpsPDf: return 'VPS PDF';
      case FileSources.StorebrandExcel: return 'Storebrand Excel (NO)';
      case FileSources.Insight: return 'Dynamik template';
      case FileSources.SAndPartners: return 'Søderberg & Partners';
      case FileSources.Sb1Forvaltning: return 'SB1 Forvaltning';
      case FileSources.VpsNO: return 'Vps (NO)';
      case FileSources.VpsEN: return 'Vps (ENG)';
      case FileSources.Pareto: return 'Pareto';
      case FileSources.Nordnet: return 'Nordnet';
      case FileSources.HandelsBanken: return 'Handelsbanken';
      case FileSources.Odin: return 'Odin';
      case FileSources.Storebrand: return 'Storebrand';
      case FileSources.Dnb: return 'DNB';
      case FileSources.SaxoBank: return 'Saxo Bank';
      case FileSources.Industrifinans: return 'Industrifinans';

      case FileSources.Non: return 'NON';
      default: return '';
    }
  }
}
